import GradientButton from "./GradientButton";
import Marquee from "./Marquee";

const About = () => {
  const handleTicketClick = () => {
    window.location.href = "https://secure.touchnet.net/C20832_ustores/web/store_main.jsp?STOREID=178&SINGLESTORE=true";
  };

  return (
    <div className="relative w-full min-h-screen flex flex-col items-center">
        {/* 배경 이미지 (하단에 붙음, 상단만 보이게 설정) */}
        <div className="absolute bottom-0 w-full desktop:h-[30vh] tablet:h-[55vh] mobile:h-[55vh] bg-[url(../public/images/about-bg.png)] desktop:bg-cover bg-no-repeat bg-[position:top_center] pointer-events-none"></div>

        {/* 메인 컨텐츠 - 가로 세로 정중앙 배치 */}
        <div className="relative flex flex-col justify-center items-center text-center z-10 w-full h-[50vh] flex-grow">
            <img src="/images/harvard-xr.svg" className="w-[158px] h-[38px] mobile:!w-[132px] mobile:h-[32.18px]" />

            <h1 className="desktop:!size-heading13xl font-extrabold tablet:text-[82px] mobile:text-[42px] heading ui desktop:leading-[115px] tablet:leading-[70px] mt-6">
            Future-facing<br />Conference on XR
            </h1>
            <h2 className="desktop:size-heading10xl tablet:size-heading10xl mobile:text-[36px] heading ui mt-4">
            April 19, 2025
            </h2>
            <button 
            className="mobile:text-[22px] tablet:text-[24px] fill size-7xl deep_purple_a200_01 button ui !rounded-[20px] backdrop-blur-[44px] min-w-[246px] desktop:text-[26px] px-[34px] mt-[46px] h-[78px] !bg-deep_purple-a200_01 font-bold !text-white sm:px-5 hover:!bg-[#5E44FF]"
            onClick={handleTicketClick}
            >
            Get tickets
            </button>
        </div>

        {/* 하단 정보 */}
        <div className="relative w-full text-center text-white text-sm font-light mt-auto pb-6">
            <Marquee />
        </div>
        </div>


  );
};

export default About;
